import { render, staticRenderFns } from "./UpdateDocument.vue?vue&type=template&id=260c78f2&scoped=true&"
import script from "./UpdateDocument.vue?vue&type=script&lang=ts&"
export * from "./UpdateDocument.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "260c78f2",
  null
  
)

export default component.exports